export default __webpack_public_path__ + "static/media/FilterIcon.4b5d8b6b.svg";